const FORMATS = ['B', 'M', 'K'];

/**
 * Format Number Abbreviation
 *
 * @param n any large number, or null, or undefined
 * @returns formatted abbreviation (ex: 3.7M) or "--" if the input is null
 */
export default function formatNumberAbbr(n: number | null | undefined): string {
  if (n == null || Number.isNaN(n)) {
    return '--';
  }

  for (let i = 0; i < FORMATS.length; i += 1) {
    const val = 10 ** (9 - i * 3);
    const div = n / val;

    if (div > 1 && div < 1000) {
      const decimalPlace = Math.round(div) === div ? 0 : 1;

      return `${(n / val).toFixed(decimalPlace)}${FORMATS[i]}`;
    }
  }

  return n > 0 && n < 1 ? `${n.toFixed(1)}` : `${n}`;
}
